/**
 * EZ-INK: show only blank-apparel images for the selected Color.
 * Uses media alt pattern "Color — front|back|side" from product JSON.
 */
(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function colorFromAlt(alt) {
    if (!alt || alt.indexOf(' — ') === -1) return '';
    // Ignore product-title alts like "Gildan 64000 — Unisex..."
    var left = alt.split(' — ')[0].trim();
    var right = alt.split(' — ').slice(1).join(' — ').trim().toLowerCase();
    if (['front', 'back', 'side', 'model_front', 'model_back', 'swatch'].indexOf(right) === -1) {
      // not a view tag — skip
      if (!/^(front|back|side)/i.test(right)) return '';
    }
    return left;
  }

  function viewFromAlt(alt) {
    if (!alt || alt.indexOf(' — ') === -1) return '';
    return alt.split(' — ').slice(1).join(' — ').trim().toLowerCase();
  }

  function optionColor(product, variant) {
    if (!product || !variant) return null;
    var opts = product.options || [];
    var idx = -1;
    for (var i = 0; i < opts.length; i++) {
      if (String(opts[i]).toLowerCase() === 'color') {
        idx = i;
        break;
      }
    }
    if (idx < 0) return null;
    if (variant.options && variant.options[idx] != null) return variant.options[idx];
    if (idx === 0) return variant.option1;
    if (idx === 1) return variant.option2;
    if (idx === 2) return variant.option3;
    return null;
  }

  function buildColorMap(product, sectionId) {
    var map = {}; // data-media-id -> {color, view}
    var mediaList = product.media || [];
    mediaList.forEach(function (m) {
      var alt = m.alt || '';
      var color = colorFromAlt(alt);
      if (!color) return;
      var id = sectionId + '-' + m.id;
      map[id] = { color: color, view: viewFromAlt(alt) };
    });
    // Also map from product.images if media missing
    if (!mediaList.length && product.images) {
      product.images.forEach(function (img) {
        var alt = img.alt || '';
        var color = colorFromAlt(alt);
        if (!color) return;
        var id = sectionId + '-' + img.id;
        map[id] = { color: color, view: viewFromAlt(alt) };
      });
    }
    return map;
  }

  function filterGallery(container, sectionId, colorMap, color) {
    if (!color) return;
    var wrappers = container.querySelectorAll('[data-product-single-media-wrapper]');
    var thumbs = container.querySelectorAll('.product-single__thumbnails-item');
    var frontId = null;
    var firstId = null;

    wrappers.forEach(function (el) {
      var mid = el.getAttribute('data-media-id') || '';
      var info = colorMap[mid];
      // also try without section prefix issues
      if (!info) {
        // try match by suffix id
        var num = mid.split('-').pop();
        info = colorMap[sectionId + '-' + num];
      }
      if (!info || !info.color) {
        // untagged media: leave alone (legacy products)
        return;
      }
      var match = info.color === color;
      el.classList.add('hide');
      if (match) {
        el.style.display = '';
        if (!firstId) firstId = mid;
        if (info.view === 'front' && !frontId) frontId = mid;
      } else {
        el.style.display = 'none';
      }
    });

    thumbs.forEach(function (li) {
      var a = li.querySelector('a[data-thumbnail-id]');
      if (!a) return;
      var mid = a.getAttribute('data-thumbnail-id') || '';
      var info = colorMap[mid];
      if (!info || !info.color) return;
      if (info.color === color) {
        li.style.display = '';
      } else {
        li.style.display = 'none';
      }
    });

    var activateId = frontId || firstId;
    if (activateId) {
      wrappers.forEach(function (el) {
        var mid = el.getAttribute('data-media-id') || '';
        var info = colorMap[mid];
        if (info && info.color === color) {
          el.classList.add('hide');
        }
      });
      var target = container.querySelector(
        '[data-product-single-media-wrapper][data-media-id="' + activateId + '"]'
      );
      if (target) {
        target.classList.remove('hide');
        target.style.display = '';
      }
      thumbs.forEach(function (li) {
        var a = li.querySelector('a[data-thumbnail-id]');
        if (!a) return;
        if (a.getAttribute('data-thumbnail-id') === activateId) {
          a.classList.add('active-thumb');
        } else {
          a.classList.remove('active-thumb');
        }
      });
    }
  }

  function boot() {
    var container = document.querySelector('[data-section-type="product"]');
    if (!container) return;
    var sectionId = container.getAttribute('data-section-id');
    if (!sectionId) return;
    var jsonEl = document.getElementById('ProductJson-' + sectionId);
    if (!jsonEl) return;

    var product;
    try {
      product = JSON.parse(jsonEl.textContent);
    } catch (e) {
      return;
    }

    var colorMap = buildColorMap(product, sectionId);
    var keys = Object.keys(colorMap);
    if (!keys.length) return; // not a color-gallery blank product

    function applyVariant(variant) {
      var color = optionColor(product, variant);
      if (color) filterGallery(container, sectionId, colorMap, color);
    }

    function currentVariant() {
      var select = document.getElementById('ProductSelect-' + sectionId);
      if (!select) return product.variants && product.variants[0];
      var id = parseInt(select.value, 10);
      for (var i = 0; i < product.variants.length; i++) {
        if (product.variants[i].id === id) return product.variants[i];
      }
      return product.variants[0];
    }

    if (window.jQuery) {
      window.jQuery(container).on('variantChange', function (evt) {
        applyVariant(evt.variant);
      });
      // Also after theme updates media
      window.jQuery(container).on('variantImageChange', function (evt) {
        applyVariant(evt.variant || currentVariant());
      });
    }

    applyVariant(currentVariant());

    // Re-apply shortly after Debut finishes init (thumbnails slider etc.)
    setTimeout(function () {
      applyVariant(currentVariant());
    }, 300);
    setTimeout(function () {
      applyVariant(currentVariant());
    }, 1000);
  }

  ready(boot);
})();
/* === ezink inventory badge (appended) === */
/* ezink-inventory.js — stock badge; respects missing color/size combos */
(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function boot() {
    var el = document.querySelector('[id^="VariantInventory-"]');
    if (!el) return;
    var sectionId = el.id.replace('VariantInventory-', '');
    var jsonEl = document.getElementById('VariantInventoryJson-' + sectionId);
    var textEl = el.querySelector('[data-inventory-text]');
    if (!jsonEl || !textEl) return;

    var data = {};
    try {
      data = JSON.parse((jsonEl.textContent || '').trim() || '{}');
    } catch (e) {
      data = {};
    }

    var qtyMap = {};
    var byOptions = {};
    if (data && data.qty && typeof data.qty === 'object') {
      qtyMap = data.qty;
      byOptions = data.byOptions || {};
    } else {
      qtyMap = data || {};
    }

    if (!byOptions || !Object.keys(byOptions).length) {
      byOptions = {};
      var productJsonEl = document.getElementById('ProductJson-' + sectionId);
      if (productJsonEl) {
        try {
          var prod = JSON.parse((productJsonEl.textContent || '').trim() || '{}');
          (prod.variants || []).forEach(function (v) {
            var key = (v.options || []).join('|');
            if (key) byOptions[key] = String(v.id);
          });
        } catch (e2) {}
      }
    }

    var hasByOptions = byOptions && Object.keys(byOptions).length > 0;
    var threshold = parseInt(el.getAttribute('data-inventory-threshold') || '1000', 10) || 1000;

    function formatQty(n) {
      try { return Number(n).toLocaleString(); } catch (e) { return String(n); }
    }
    function qtyForId(id) {
      if (id == null || id === '') return null;
      var key = String(id);
      if (Object.prototype.hasOwnProperty.call(qtyMap, key)) return qtyMap[key];
      if (key.indexOf('/') !== -1) {
        var tail = key.split('/').pop();
        if (Object.prototype.hasOwnProperty.call(qtyMap, tail)) return qtyMap[tail];
      }
      return null;
    }
    function selectedOptionValues() {
      var root = document.getElementById('ProductSection-' + sectionId) || document;
      var vals = [];
      root.querySelectorAll('.single-option-selector, .single-option-selector-' + sectionId).forEach(function (sel) {
        vals.push(sel.value);
      });
      return vals;
    }
    function optionKey() {
      return selectedOptionValues().join('|');
    }
    function resolveVariantId() {
      var opts = selectedOptionValues();
      var key = optionKey();
      if (hasByOptions && opts.length) {
        if (byOptions[key]) return String(byOptions[key]);
        return null;
      }
      var select = document.getElementById('ProductSelect-' + sectionId);
      if (select && select.value) return String(select.value);
      var hidden = document.querySelector('#ProductSection-' + sectionId + ' [name="id"]');
      if (hidden && hidden.value) return String(hidden.value);
      if (key && byOptions[key]) return String(byOptions[key]);
      return null;
    }
    function showUnavailable(msg) {
      textEl.innerHTML = msg || 'Unavailable for this color/size';
      el.style.display = '';
      el.style.color = '#b30000';
    }
    function update(variantId, available) {
      if (!variantId) {
        showUnavailable('Unavailable for this color/size');
        return;
      }
      var qty = qtyForId(variantId);
      if (qty === null || typeof qty === 'undefined') {
        if (available === false) {
          showUnavailable('Unavailable for this color/size');
          return;
        }
        textEl.innerHTML = '';
        el.style.display = 'none';
        return;
      }
      qty = parseInt(qty, 10);
      if (isNaN(qty)) {
        el.style.display = 'none';
        return;
      }
      el.style.display = '';
      if (available === false) {
        showUnavailable(
          qty <= 0 ? 'Out of stock for this color/size' : 'Unavailable for this color/size'
        );
        return;
      }
      if (qty <= 0) {
        textEl.innerHTML = 'Out of stock for this color/size';
        el.style.color = '#b30000';
      } else if (qty < threshold) {
        textEl.innerHTML = '<strong>' + formatQty(qty) + '</strong> available for this color/size';
        el.style.color = qty < 50 ? '#b30000' : '#1a1a1a';
      } else {
        textEl.innerHTML = '<strong>1,000+</strong> available for this color/size';
        el.style.color = '#64748b';
      }
    }
    function refresh() {
      var opts = selectedOptionValues();
      var key = optionKey();
      if (hasByOptions && opts.length >= 2 && key && !byOptions[key]) {
        showUnavailable('Unavailable for this color/size');
        return;
      }
      var id = resolveVariantId();
      if (!id) {
        if (opts.length >= 2) showUnavailable('Unavailable for this color/size');
        return;
      }
      var available = true;
      var select = document.getElementById('ProductSelect-' + sectionId);
      if (select) {
        if (!select.value) available = false;
        else if (select.selectedIndex >= 0) {
          var t = select.options[select.selectedIndex].textContent || '';
          if (/sold out|unavailable/i.test(t)) available = false;
        }
      }
      if (hasByOptions && key && byOptions[key]) id = String(byOptions[key]);
      if (hasByOptions && key && !byOptions[key]) {
        showUnavailable('Unavailable for this color/size');
        return;
      }
      update(id, available);
    }

    var container = document.getElementById('ProductSection-' + sectionId);
    if (container && window.jQuery) {
      jQuery(container).on('variantChange', function (evt) {
        if (!evt || !evt.variant || !evt.variant.id) {
          showUnavailable('Unavailable for this color/size');
          setTimeout(refresh, 0);
          return;
        }
        var key = optionKey();
        if (hasByOptions && key && !byOptions[key]) {
          showUnavailable('Unavailable for this color/size');
          return;
        }
        update(String(evt.variant.id), evt.variant.available !== false);
      });
    }
    document.addEventListener(
      'change',
      function (e) {
        var t = e.target;
        if (!t) return;
        if (
          (t.classList && t.classList.contains('single-option-selector')) ||
          t.name === 'id' ||
          (t.id && (t.id.indexOf('ProductSelect-') === 0 || t.id.indexOf('SingleOptionSelector') === 0))
        ) {
          setTimeout(refresh, 0);
          setTimeout(refresh, 50);
          setTimeout(refresh, 200);
        }
      },
      true
    );

    var last = '';
    setInterval(function () {
      var sig = (resolveVariantId() || '') + '::' + optionKey();
      if (sig !== last) {
        last = sig;
        refresh();
      }
    }, 150);

    refresh();
    setTimeout(refresh, 100);
    setTimeout(refresh, 400);
  }

  ready(boot);
})();
